import { AdLayoutWatchdog } from 'components/util/AdLayoutWatchdog/AdLayoutWatchdog';
import { Microsites } from 'constants/constants';
import HEADER_NAVIGATION from 'constants/testsIds/headerNavigation';
import useBreakpoint from 'hooks/useBreakpoint';
import { type ForwardedRef, forwardRef, useContext } from 'react';
import DesktopNavigationBar from './DesktopNavigationBar';
import MobileNavigationBar from './MobileNavigationBar';
import * as S from './NavigationBarStyles';
import { UserContext } from 'providers/UserProvider';
import { isArticlePagePath } from '@/app_lib/utils/utils';
import { useRouter } from 'next/router';

export interface NavigationBarProps {
  domainLogo: string | null;
  subDomain: string;
  logoHref: string;
  id?: string;
}

export const showInstreamAd = (micrositeDomain: string | undefined) => {
  googletag
    .defineSlot(
      `/21809533738/${Microsites.Well === micrositeDomain ? 'fortune.well' : 'fortune'}/search/advancedsearch/instream`,
      [
        [728, 90],
        [300, 250],
        [336, 280],
      ],
      'InstantSearch_InStream0',
    )
    ?.addService(googletag.pubads());
  googletag.pubads().refresh();
  document.getElementById('queryly_query')?.addEventListener('keydown', () => {
    googletag.pubads().refresh();
  });
};

const NavigationBar = (props: NavigationBarProps, ref: ForwardedRef<HTMLLabelElement> | null) => {
  const { domainLogo, subDomain, logoHref, id } = props;
  const isMobileBrowser = useBreakpoint('mdMax');
  const isTablet = useBreakpoint('lgMax');
  const { isMobileApp } = useContext(UserContext);
  const { asPath } = useRouter();
  const isArticlePage = isArticlePagePath(asPath);
  const hideForMobileApp = isMobileApp && isArticlePage;

  return (
    <S.Wrapper
      id={id}
      data-cy={HEADER_NAVIGATION.HEADER_NAV_BAR}
      $isMobile={isMobileBrowser}
      $isTablet={isTablet}
      hideForMobileApp={hideForMobileApp}
    >
      <AdLayoutWatchdog matchAdUnits={['/fortune/leaderboard_top']} />
      {hideForMobileApp ? null : isMobileBrowser ? (
        <MobileNavigationBar
          subDomain={subDomain}
          domainLogo={domainLogo}
          logoHref={logoHref}
          ref={ref}
        />
      ) : (
        <DesktopNavigationBar
          subDomain={subDomain}
          domainLogo={domainLogo}
          logoHref={logoHref}
        />
      )}
    </S.Wrapper>
  );
};

export default forwardRef(NavigationBar);
